import React from 'react'
import styled from "styled-components";


const FirstContainer = styled.div``;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url("https://previews.123rf.com/images/kaymosk/kaymosk1804/kaymosk180400006/100130939-error-404-page-not-found-error-with-glitch-effect-on-screen-vector-illustration-for-your-design-.jpg")
      center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 25%;
  padding: 20px;
  background-color: white;
  border-radius: 11px;


`;
const Subtitle = styled.span`
  font-size: 14px;
  color: crimson;
`;

const DeadLine = () => {
  return (
   <FirstContainer>
      <Container>
        <Wrapper>
          <Subtitle>
            La fecha para reservar ha caducado
          </Subtitle>
        </Wrapper>
      </Container>
   </FirstContainer>
  )
}

export default DeadLine